import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-filter-text-dialog',
  templateUrl: './filter-text-dialog.component.html',
  styleUrls: ['./filter-text-dialog.component.scss']
})
export class FilterTextDialogComponent implements OnInit {

  @Input() displayDialog : boolean = false;
  @Input() placeholder: String = '';
  @Input() dialogTitle : String = '';
  @Input() dialogData : String= '';
  @Input() dialogtype : String='';

  @Output() filterReset = new EventEmitter<String>();
  @Output() filterApplied = new EventEmitter< {data: String ,type: String}>();
  constructor() { }

  ngOnInit(): void {
    
  }

  resetFilter() {
    this.dialogData ='';
    this.filterReset.emit(this.dialogtype);
  }

  applyFilter() {
    this.filterApplied.emit( {data: this.dialogData,type: this.dialogtype});
    this.dialogData='';
  }

}
